import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
import { onMounted, reactive, computed, watchEffect } from 'vue';
import axios from 'axios';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import { useCompanyBillingStore } from './companyBillingStore.js';
import RouteService from '@/services/RouteService';
import UpgradeToProExpenseAttachmentsModals from '@/components/modals/UpgradeToProExpenseAttachmentsModals.vue';
import Loader from '@/components/Loader.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import { resolveCostType } from '@/utils/expenseHelpers';
export default {
  __name: 'SetUpExpensesDialogs',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    companyBillingState: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl
    } = useSupportChat();
    const props = __props;
    const setupExpensesDialogState = reactive({
      step: 0,
      me: {},
      loading: false,
      company: {},
      accounts: [],
      services: [],
      service: {
        account: {
          name: ''
        }
      },
      includeVendorInDescription: false,
      includeCheckNumberInDescription: false,
      syncAttachments: false,
      defaultCostType: 'soft',
      hard: {
        sync: false,
        syncAccount: {
          account: {
            name: ''
          },
          service: {
            name: ''
          }
        },
        syncDate: null
      },
      showUpgradeToProExpenseAttachmentsModals: false,
      routeService: undefined,
      dialog: false,
      currentTitle: null,
      masks: {
        input: 'MM-DD-YYYY'
      }
    });
    const companyBillingStore = useCompanyBillingStore();
    companyBillingStore.alerts = props.alerts;
    setupExpensesDialogState.routeService = new RouteService(props);
    onMounted(async () => {
      setupExpensesDialogState.loading = true;
      await loadExpenseSettings();
      setupExpensesDialogState.loading = false;
    });

    // Watch for changes in company settings and reload expense settings
    watchEffect(async () => {
      // Watch the company settings for expense configuration changes
      const expenseSettings = props.companyBillingState?.me?.company?.settings?.expenses;
      if (expenseSettings && !setupExpensesDialogState.loading) {
        await loadExpenseSettings();
      }
    });
    async function includeVendorInDescriptionChange() {
      try {
        const currentExpenseSettings = setupExpensesDialogState.me?.company?.settings?.expenses || {};
        await axios.put('/me/company', {
          settings: {
            expenses: {
              ...currentExpenseSettings,
              includeVendorInDescription: setupExpensesDialogState.includeVendorInDescription
            }
          }
        });
      } catch (error) {
        console.error('Failed to update vendor description setting:', error);
      }
    }
    async function includeCheckNumberInDescriptionChange() {
      const currentExpenseSettings = setupExpensesDialogState.me?.company?.settings?.expenses || {};
      const previousValue = currentExpenseSettings.includeCheckNumberInDescription ?? false;
      try {
        await axios.put('/me/company', {
          settings: {
            expenses: {
              ...currentExpenseSettings,
              includeCheckNumberInDescription: setupExpensesDialogState.includeCheckNumberInDescription
            }
          }
        });
        if (setupExpensesDialogState.me?.company?.settings?.expenses) {
          setupExpensesDialogState.me.company.settings.expenses.includeCheckNumberInDescription = setupExpensesDialogState.includeCheckNumberInDescription;
        }
      } catch (error) {
        setupExpensesDialogState.includeCheckNumberInDescription = previousValue;
        props.alerts?.error('Failed to update check number description setting');
      }
    }
    async function defaultCostTypeChange() {
      const currentExpenseSettings = setupExpensesDialogState.me?.company?.settings?.expenses || {};
      await companyBillingStore.updateCompanySettings({
        settings: {
          expenses: {
            ...currentExpenseSettings,
            defaultCostType: setupExpensesDialogState.defaultCostType
          }
        }
      });
      if (setupExpensesDialogState.me?.company?.settings?.expenses) {
        setupExpensesDialogState.me.company.settings.expenses.defaultCostType = setupExpensesDialogState.defaultCostType;
      }
    }
    const changeSettings = () => {
      // setupExpensesDialogState.dialog = true;
      props.companyBillingState.openWizardDialog = true;
    };
    const done = () => {
      props.companyBillingState.updatedExpenseSettings = false;
      props.companyBillingState.openSetUpExpensesDialog = false;
    };
    const syncAttachmentsChange = async () => {
      if (!setupExpensesDialogState.me.features.expenseAttachments) {
        setupExpensesDialogState.showUpgradeToProExpenseAttachmentsModals = true;
        return;
      }

      // Get current expense settings and update only the specific field
      try {
        const currentExpenseSettings = setupExpensesDialogState.me?.company?.settings?.expenses || {};
        await axios.put('/me/company', {
          settings: {
            expenses: {
              ...currentExpenseSettings,
              syncAttachments: setupExpensesDialogState.syncAttachments
            }
          }
        });
      } catch (error) {
        console.error('Failed to update sync attachments setting:', error);
      }
    };
    const updateTitleOnNext = (title, step) => {
      setupExpensesDialogState.currentTitle = title;
    };
    async function loadExpenseSettings() {
      if (props.companyBillingState.openExpenseModal) {
        setupExpensesDialogState.dialog = true;
      }
      const [me, services, accounts] = await Promise.all([await props.userService.getMe(), await props.accountingService.services(), await props.accountingService.accounts()]);
      setupExpensesDialogState.me = me;
      setupExpensesDialogState.services = services;
      setupExpensesDialogState.accounts = accounts;
      setupExpensesDialogState.company = me.company;
      setupExpensesDialogState.services = services.services;
      setupExpensesDialogState.accounts = [...accounts.expense, ...accounts.liability, ...accounts.income, ...accounts.asset];
      setupExpensesDialogState.accounts.forEach(a => a.label = `${a.name} (${a.type})`);
      // Set initial settings from company data
      const settings = setupExpensesDialogState.me?.company?.settings?.expenses || {
        includeVendorInDescription: true
      };
      setupExpensesDialogState.includeVendorInDescription = settings.includeVendorInDescription;
      setupExpensesDialogState.includeCheckNumberInDescription = settings.includeCheckNumberInDescription;
      setupExpensesDialogState.syncAttachments = settings.syncAttachments;
      setupExpensesDialogState.defaultCostType = resolveCostType(settings.defaultCostType);
      if (settings.accountingService) {
        setupExpensesDialogState.service = settings.accountingService;
        const found = setupExpensesDialogState.services.find(s => s.id === setupExpensesDialogState.service.id);
        if (found) {
          setupExpensesDialogState.service = found;
        } else {
          setupExpensesDialogState.service.invalid = true;
        }
      }
      setupExpensesDialogState.hard.sync = settings.sync;
      setupExpensesDialogState.hard.syncAccount = settings.syncAccounts ? settings.syncAccounts[0] : null;
      if (settings.syncAccounts) {
        const found = setupExpensesDialogState.accounts.find(s => s.id === setupExpensesDialogState.hard.syncAccount.id);
        if (found) {
          setupExpensesDialogState.hard.syncAccount = found;
        } else {
          setupExpensesDialogState.hard.syncAccount.invalid = true;
        }
      }
      setupExpensesDialogState.hard.syncDate = settings.syncDate;
    }
    function openSupportLink() {
      window.open(getSupportUrl('expenseAttachments'), '_blank');
    }
    const close = () => {
      setupExpensesDialogState.dialog = false;
    };
    return (_ctx, _cache) => {
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, {
        class: "w-full"
      }, {
        default: _withCtx(() => [setupExpensesDialogState.loading ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          what: 'Expense Configuration',
          class: "my-16 px-6"
        })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_row, {
          class: "pa-4"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_row, {
            class: "pa-0"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createElementVNode("h4", null, "Created in QuickBooks (Hard cost)", -1), _createElementVNode("p", {
                class: "text-left"
              }, " Expenses created in QuickBooks will appear in LeanLaw for invoicing as long as they're assigned to a client linked to LeanLaw and use the Account established below as their Category in QuickBooks ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createElementVNode("h4", null, "Created in LeanLaw (Soft cost)", -1), _createElementVNode("p", {
                class: "text-left"
              }, " Expenses created in LeanLaw will not appear in QuickBooks' Expenses page. Expenses appear in QuickBooks' Invoices page as soon as you invoice them in LeanLaw. The expense line item will use the Product/Service established here. ", -1)]))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_row, {
            class: "pa-0"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("label", null, " Expenses are not sync'ed from QuickBooks ", 512), [[_vShow, !setupExpensesDialogState?.hard?.sync]]), setupExpensesDialogState?.hard?.sync ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[19] || (_cache[19] = _createElementVNode("label", null, "Account", -1)), _createVNode(LlTextField, {
                modelValue: setupExpensesDialogState.hard.syncAccount.account.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => setupExpensesDialogState.hard.syncAccount.account.name = $event),
                variant: "outlined",
                color: "primary",
                "hide-details": "",
                density: "compact",
                placeholder: "Account in QuickBooks",
                readonly: "",
                cursor: "none"
              }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("label", null, [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
                class: "fa fa-warning"
              }, null, -1), _createTextVNode(" Not Configured ", -1)]))], 512), [[_vShow, !setupExpensesDialogState.service]]), _withDirectives(_createElementVNode("div", null, [_cache[21] || (_cache[21] = _createElementVNode("label", null, "Account", -1)), _createVNode(LlTextField, {
                modelValue: setupExpensesDialogState.service.account.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => setupExpensesDialogState.service.account.name = $event),
                variant: "outlined",
                color: "primary",
                "hide-details": "",
                density: "compact",
                placeholder: "Account in LeanLaw",
                readonly: "",
                cursor: "none"
              }, null, 8, ["modelValue"])], 512), [[_vShow, setupExpensesDialogState.service]])]),
              _: 1
            }), _createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [setupExpensesDialogState?.hard?.sync ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[22] || (_cache[22] = _createElementVNode("label", null, "Product/Service", -1)), _createVNode(LlTextField, {
                modelValue: setupExpensesDialogState.hard.syncAccount.service.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => setupExpensesDialogState.hard.syncAccount.service.name = $event),
                variant: "outlined",
                color: "primary",
                "hide-details": "",
                density: "compact",
                placeholder: "Product/Service in QuickBooks",
                readonly: "",
                cursor: "none"
              }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("label", null, "Product/Service", -1)), _createVNode(LlTextField, {
                modelValue: setupExpensesDialogState.service.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => setupExpensesDialogState.service.name = $event),
                variant: "outlined",
                color: "primary",
                "hide-details": "",
                density: "compact",
                placeholder: "Product/Service in LeanLaw",
                readonly: "",
                cursor: "none"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _withDirectives(_createVNode(_component_v_col, {
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [_createVNode(LlDatePicker, {
                modelValue: setupExpensesDialogState.hard.syncDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => setupExpensesDialogState.hard.syncDate = $event),
                readonly: "",
                disabled: true,
                label: "Only from this date",
                showButton: false
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 512), [[_vShow, setupExpensesDialogState?.hard?.sync]])]),
            _: 1
          }), _createVNode(_component_v_row, {
            class: "cols-12"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_col, {
              class: "pa-0",
              cols: "12"
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(LlCheckbox, {
                modelValue: setupExpensesDialogState.includeVendorInDescription,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => setupExpensesDialogState.includeVendorInDescription = $event),
                label: "Include vendor/payee names in descriptions",
                info: "When syncing expenses into LeanLaw, the vendor name (or payee name) will be prepended to the description",
                onCheckboxClick: _cache[6] || (_cache[6] = $event => includeVendorInDescriptionChange())
              }, null, 8, ["modelValue"]), [[_vShow, setupExpensesDialogState?.hard?.sync]]), _withDirectives(_createVNode(LlCheckbox, {
                modelValue: setupExpensesDialogState.includeCheckNumberInDescription,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => setupExpensesDialogState.includeCheckNumberInDescription = $event),
                label: "Include check number in invoice descriptions",
                info: "When enabled, the check number — whether from a paid bill or a directly-recorded check — will be appended to expense descriptions on invoice PDFs and LEDES exports",
                onCheckboxClick: _cache[8] || (_cache[8] = $event => includeCheckNumberInDescriptionChange())
              }, null, 8, ["modelValue"]), [[_vShow, setupExpensesDialogState?.hard?.sync]]), _withDirectives(_createVNode(LlCheckbox, {
                modelValue: setupExpensesDialogState.syncAttachments,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => setupExpensesDialogState.syncAttachments = $event),
                label: "Sync attachments from QuickBooks to LeanLaw",
                info: "When syncing expenses into LeanLaw, the attachments will also be synced",
                onCheckboxClick: _cache[10] || (_cache[10] = $event => syncAttachmentsChange())
              }, null, 8, ["modelValue"]), [[_vShow, setupExpensesDialogState.me?.features?.expenseAttachments]])]),
              _: 1
            }), setupExpensesDialogState.me?.features?.uiHardCostCreation ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              class: "pa-2",
              cols: "6"
            }, {
              default: _withCtx(() => [_createVNode(LlSelect, {
                modelValue: setupExpensesDialogState.defaultCostType,
                "onUpdate:modelValue": [_cache[11] || (_cache[11] = $event => setupExpensesDialogState.defaultCostType = $event), _cache[12] || (_cache[12] = $event => defaultCostTypeChange())],
                label: "Default cost type for new expenses",
                items: [{
                  label: 'Soft cost',
                  id: 'soft'
                }, {
                  label: 'Hard cost — Bill',
                  id: 'bill'
                }, {
                  label: 'Hard cost — Check',
                  id: 'check'
                }],
                "return-object": false,
                "hide-details": "",
                dataCy: "select-default-cost-type"
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_v_col, {
              cols: "12"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_row, {
                class: "pa-2 mt-4",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  value: "changeSettings",
                  class: "p-0 w-1/2 mr-2",
                  color: "primary",
                  onClick: changeSettings
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" Change Settings ", -1)]))]),
                  _: 1
                }), _createVNode(LlSecondaryButton, {
                  class: "p-0 w-2/5",
                  onBtnClick: _cache[13] || (_cache[13] = $event => done())
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Done ", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_dialog, {
          modelValue: setupExpensesDialogState.showUpgradeToProExpenseAttachmentsModals,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => setupExpensesDialogState.showUpgradeToProExpenseAttachmentsModals = $event),
          width: "700"
        }, {
          default: _withCtx(() => [_createVNode(UpgradeToProExpenseAttachmentsModals, {
            routeService: __props.companyBillingState.routeService,
            tracking: _ctx.tracking,
            onCancel: _cache[14] || (_cache[14] = $event => (setupExpensesDialogState.showUpgradeToProExpenseAttachmentsModals = false, done())),
            onOpenSupportLink: _cache[15] || (_cache[15] = $event => openSupportLink())
          }, null, 8, ["routeService", "tracking"])]),
          _: 1
        }, 8, ["modelValue"])]))]),
        _: 1
      });
    };
  }
};